module.exports = __webpack_public_path__ + "img/vip-300.383ae227.png";